import whatIsForexTradingContent from "./content/what-is-forex-trading.json";

export const whatIsForexTradingMock = {
  name: "what-is-forex-trading",
  layoutType: 1,
  areasList: [
    {
      id: "what-is-forex-trading-1",
      name: "what-is-forex-trading-content",
      componentName: "Comp:WhatIsForexTradingPage",
      content: JSON.stringify(whatIsForexTradingContent),
    },
  ],
};
